export default __webpack_public_path__ + "static/media/Rita_Segurado_1.b2473c1b.webp";